import React, { useState, useEffect } from 'react';
import {
    Container, Typography, Box, Paper, CircularProgress
} from '@mui/material';
import { parkedDomain } from '../App/utils';
import { getDomainPublicSettings } from '../API/KB/KBAPI';

export const TermsOfUse = () => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [companyName, setCompanyName] = useState('OpenKBS');

    useEffect(() => {
        const loadContent = async () => {
            if (parkedDomain) {
                try {
                    const settings = await getDomainPublicSettings(parkedDomain);
                    if (settings?.TERMS_OF_USE) {
                        setContent(settings.TERMS_OF_USE);
                    }
                    if (settings?.COMPANY_NAME) {
                        setCompanyName(settings.COMPANY_NAME);
                    }
                } catch (error) {
                    console.error('Failed to load terms of use:', error);
                }
            }
            setLoading(false);
        };
        loadContent();
    }, []);

    if (loading) {
        return (
            <Container>
                <Box display="flex" justifyContent="center" mt={5}>
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    // No default content - if no data from API, show nothing
    if (!content || !content.sections || content.sections.length === 0) {
        return null; // Don't render anything if no content
    }

    return (
        <Container maxWidth="md">
            <Paper sx={{ p: 4, mt: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Terms of Use
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Last updated: {new Date().toLocaleDateString()}
                </Typography>

                {content.sections?.map((section, index) => (
                    <Box key={index} sx={{ mt: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            {section.title}
                        </Typography>
                        <Typography variant="body1" paragraph style={{ whiteSpace: 'pre-wrap' }}>
                            {section.content}
                        </Typography>
                    </Box>
                ))}
            </Paper>
        </Container>
    );
};
